import { render, staticRenderFns } from "./WorkTypeAccordion.vue?vue&type=template&id=64376ee1&scoped=true&"
import script from "./WorkTypeAccordion.vue?vue&type=script&lang=js&"
export * from "./WorkTypeAccordion.vue?vue&type=script&lang=js&"
import style0 from "./WorkTypeAccordion.vue?vue&type=style&index=0&id=64376ee1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64376ee1",
  null
  
)

export default component.exports